import React from "react";

import styled from "@emotion/styled";

import cls from "../../../utils/cls";

const lookLikeSizes = {
    one: "2em",
    two: "1.5em",
    three: "1.2em",
    four: "1.1em",
    five: "1em",
};

const modifierProps = ["isCenter", "isLight", "lookLikeVariant"];

const StyledHeadline = styled("div", {
    shouldForwardProp: (prop) => !modifierProps.includes(prop),
})`
    font-size: 1.5em;
    font-weight: 400;
    line-height: 30px;
    margin-bottom: 10px;

    &.def {
        font-size: 1.5em !important;
        font-weight: 400;
    }

    ${({ isCenter }) => isCenter && `text-align: center;`}
    ${({ isLight }) => isLight && `font-weight: 100 !important;`}

    ${({ lookLikeVariant }) =>
        lookLikeVariant && `font-weight: 400 !important;`}
    ${({ lookLikeVariant }) =>
        lookLikeVariant &&
        lookLikeSizes[lookLikeVariant] &&
        `font-size: ${lookLikeSizes[lookLikeVariant]} !important;`}
    ${({ lookLikeVariant }) =>
        lookLikeVariant === "one" &&
        `
        @media screen and (max-width: 767px) {
            font-size: 1em;
        }
    `}
`;

/** @deprecated Use components/base/atoms/Headline instead */
const Headline = ({
    is = null,
    lookLike = "default",
    children,
    className = "",
    center = false,
    light = false,
    ...headlineProps
}) => {
    let Tag = "div";
    if (is && is >= 1 && is <= 5) {
        Tag = `h${parseInt(is)}`;
    }

    const headlines = {
        1: "one",
        2: "two",
        3: "three",
        4: "four",
        5: "five",
        default: "default",
    };
    const lookLikeVariant =
        lookLike !== null && headlines[lookLike]
            ? headlines[lookLike] === "default"
                ? "def"
                : headlines[lookLike]
            : null;

    return (
        <StyledHeadline
            as={Tag}
            className={cls(
                className,
                lookLikeVariant,
                lookLikeVariant && "headline"
            )}
            isCenter={center}
            isLight={light}
            lookLikeVariant={lookLikeVariant}
            {...headlineProps}
        >
            {children}
        </StyledHeadline>
    );
};

export default Headline;
